import React, { Component } from 'react';
import { config } from '../config';
import { storage, db } from '../ThirdPartyIntegration/firebaseClient';
import { browserHistory } from 'react-router';
import { CircularProgress } from 'material-ui/Progress';


class EditPhoto extends Component {
    canvas = null;
    ctx = null;
    flag = false;
    prevX = 0;
    currX = 0;
    prevY = 0;
    currY = 0;
    color = 'black';
    thickness = 4;

    constructor() {
        super();

        let userJsonString = window.localStorage.getItem(config.localstorage.userKey);
        let user = JSON.parse(userJsonString);

        this.state = {
            canvasBackground: new Image(),
            user: user
        }

        this.findxy = this.findxy.bind(this);
        this.findxy = this.findxy.bind(this);
        this.findxy = this.findxy.bind(this);

        this.saveNewImage = this.saveNewImage.bind(this);
        this.resetCanvas = this.resetCanvas.bind(this);
    }

    _preventDefault(e) {
        e.preventDefault();
    }

    componentDidMount() {
        this.resetCanvas();

        window.addEventListener('touchmove', this._preventDefault, { passive: false });
    }

    componentWillUnmount() {
        window.removeEventListener('touchmove', this._preventDefault, { passive: false });
    }

    resetCanvas() {
        var c = this.refs.canvas;
        var ctx = this.ctx = c.getContext("2d");

        var locationState = this.props.location.state;

        let img = this.state.canvasBackground;
        img.crossOrigin = 'anonymous';
        img.onload = function () {
            c.width = img.width;
            c.height = img.height;
            ctx.drawImage(img, 0, 0);

            if (locationState.faces) {
                console.log('there are faces');
                const faces = locationState.faces;

                // Now draw boxes around all the faces
                ctx.fillStyle = '#000';
                ctx.lineWidth = '1';

                faces.forEach((face) => {
                    ctx.beginPath();
                    let origX = 0;
                    let origY = 0;
                    face.boundingPoly.vertices.forEach((bounds, i) => {
                        if (i === 0) {
                            origX = bounds.x;
                            origY = bounds.y;
                        }
                        ctx.lineTo(bounds.x, bounds.y);
                    });
                    ctx.lineTo(origX, origY);
                    ctx.closePath();
                    ctx.fill();
                });
            }
        };
        img.src = this.state.user.picture;
    }

    saveNewImage() {
        // get the user's uid
        let user = this.state.user;

        this.setState({
            isUploading: true,
            uploadProgress: 0
        });

        this.refs.canvas.toBlob((blob) => {
            let filename = new Date().getTime();
            var metadata = {
                contentType: 'image/png'
            };

            // Upload file and metadata to the object 'images/mountains.jpg'
            var uploadTask = storage.ref().child(`images/${user.uid}/${filename}`).put(blob, metadata);

            var c = this;

            // Listen for state changes, errors, and completion of the upload.
            uploadTask.on('state_changed',
                function (snapshot) {
                    // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
                    var progress = Math.round((snapshot.bytesTransferred / snapshot.totalBytes) * 100);
                    c.setState({
                        isUploading: true,
                        uploadProgress: progress
                    });
                    console.log('Upload is ' + progress + '% done');
                    switch (snapshot.state) {
                        case 'paused':
                            console.log('Upload is paused');
                            break;
                        case 'running':
                            console.log('Upload is running');
                            break;
                        default:
                            console.log(snapshot.state);
                    }
                }, function (error) {

                    // A full list of error codes is available at
                    // https://firebase.google.com/docs/storage/web/handle-errors
                    switch (error.code) {
                        case 'storage/unauthorized':
                            // User doesn't have permission to access the object
                            console.log('access denied');
                            break;

                        case 'storage/canceled':
                            // User canceled the upload
                            console.log('upload cancelled');
                            break;
                        case 'storage/unknown':
                            // Unknown error occurred, inspect error.serverResponse
                            console.log('unknown error');
                            break;
                        default:
                            console.log(error);
                    }
                }, function () {
                    // Upload completed successfully, now we can get the download URL
                    var downloadURL = uploadTask.snapshot.downloadURL;

                    user.picture = downloadURL;
                    db.ref().child(`users/${user.uid}/info`).set(user).then(() => {
                        c.setState({ isUploading: false });
                        browserHistory.push('/loggedin/profile');
                    }).catch((e) => {
                        console.log(e);
                    });
                });
        });
    }

    findxy(res, e) {
        if (res === 'down') {
            this.prevX = this.currX;
            this.prevY = this.currY;
            this.currX = e.clientX - this.refs.canvas.offsetLeft;
            this.currY = e.clientY - this.refs.canvas.offsetTop;

            this.flag = true;
            this.dot_flag = true;
            if (this.dot_flag) {
                this.ctx.beginPath(this.currX + ", " + this.currY);
                this.ctx.fillStyle = this.thickness;
                this.ctx.fillRect(this.currX, this.currY, this.thickness, this.thickness);
                this.ctx.closePath();
                this.dot_flag = false;
            }
        }
        if (res === 'up' || res === "out") {
            this.flag = false;
        }
        if (res === 'move') {
            if (this.flag) {
                this.prevX = this.currX;
                this.prevY = this.currY;

                let clientX = e.clientX;
                let clientY = e.clientY;
                if (!(clientX && clientY)) {
                    let touch = e.touches[0];
                    clientX = touch.pageX;
                    clientY = touch.pageY;
                }
                console.log(`${clientX}, ${clientY}`)
                this.currX = clientX - this.refs.canvas.offsetLeft;
                this.currY = clientY - this.refs.canvas.offsetTop;
                this.draw();
            }
        }
    }

    draw() {
        let ctx = this.ctx;

        ctx.beginPath();
        ctx.moveTo(this.prevX, this.prevY);
        ctx.lineTo(this.currX, this.currY);
        ctx.strokeStyle = this.color;
        ctx.lineWidth = this.thickness;
        ctx.stroke();
        ctx.closePath();
    }

    render() {
        if (this.state.isUploading) {
            if (this.state.uploadProgress === 100) {
                return (
                    <p>Upload done. One sec...</p>
                )
            }
            return (
                <div>
                    Uploading image.
                    <CircularProgress mode="determinate" value={this.state.uploadProgress} />
                </div>
            )
        }
        return (
            <div>
                <canvas
                    ref='canvas'
                    onMouseMove={(e) => { this.findxy('move', e) }}
                    onMouseDown={(e) => { this.findxy('down', e) }}
                    onMouseUp={(e) => { this.findxy('up', e) }}
                    onMouseOut={(e) => { this.findxy('out', e) }}

                    onTouchStart={(e) => { this.findxy('down', e); console.log('touch start'); }}
                    onTouchMove={(e) => { this.findxy('move', e); console.log('touch move'); }}
                    onTouchEnd={(e) => { this.findxy('up', e); console.log('touch end'); }}
                />
                Faces are automatically covered. Draw over other parts of your picture, for more privacy.
                <button onClick={this.resetCanvas}>Clear</button>
                <button onClick={this.saveNewImage}>save</button>
            </div>
        )
    }
}

export default EditPhoto;


// WEBPACK FOOTER //
// ./src/Components/EditPhoto.jsx